<a class="no-underline no-vertical-pad">
    <aggregate-card *ngIf="isLoaded" [aggregate]="aggregate" [aggregateCriteria]="aggregateCriteria" [chartConfiguration]="chartConfiguration" icon="monetization_on">
    </aggregate-card>

    <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>
</a>